// Voucher reward types, mirroring MintyMerReward on the backend.
export const PERCENTAGE_OFF = 1
export const FIXED_AMOUNT_OFF = 2
export const FREE_ITEM = 3
export const TRANSACTION_STATUS_SUCCESS = 1
export const TAKE_AWAY = 1
export const DINE_IN = 2
export const ORDER = 1;
export const REQUEST = 2;
export const STRIPE = 1;
export const ALLINPAY = 2;
export const AIRWALLEX = 3;
export const QLUB = 5;
export const KIOSK_WEIGH_MIN_ADD_CART = 10;

// The applied promo code can no longer be used (out of its schedule / expired, used up,
// disabled ...): the cart shows why in a modal and drops it.
export const PROMO_CODE_ERRORS = ["PROMO_NOT_IN_SCHEDULE", "PROMO_CODE_INVALID"];
export const isPromoCodeError = (data) => !!data && PROMO_CODE_ERRORS.includes(data.error_code);

// paymentStatus.code values for the two Allinpay timeout screens.
export const ALLINPAY_TIMEOUT_RETRY = "allinpay_timeout_retry";
export const ALLINPAY_TIMEOUT_FINAL = "allinpay_timeout_final";

// Allinpay card query came back with no verdict (terminal/gateway timeout).
// The card may already have been charged, so neither message may say the
// payment failed. The first re-queries on its own; the second is the dead end.
export const ALLINPAY_TIMEOUT_MESSAGE =
  "We could not confirm your payment in time.<br>Please wait, we are checking again.";
export const ALLINPAY_TIMEOUT_COUNTER_MESSAGE =
  "We still could not confirm your payment.<br>Please show your phone payment record at the counter to collect your items.";
// MTH045: sessionStorage gate so the post-login promo popup shows once per login.
export const MENU_POPUP_SESSION_KEY = "MOO_MENU_POPUP_SHOWN";

// M920: which MOO page a scanned table QR opens. Mirrors MintyBranch::QR_REDIRECT_PAGE
// in minty.crm.api — the branch column moo_qr_redirect_page holds one of these.
export const QR_REDIRECT_LANDING_PAGE = 1;
export const QR_REDIRECT_LOGIN_PAGE = 2;
export const QR_REDIRECT_ORDERING_PAGE = 3;
export const QR_REDIRECT_MEMBER_PAGE = 4;

// M921: which MOO page opens once a shopper finishes signing in or registering.
// Mirrors MintyBranch::AFTER_LOGIN_PAGE in minty.crm.api (column moo_after_login_page).
export const AFTER_LOGIN_ORDERING_PAGE = 1;
export const AFTER_LOGIN_MEMBER_PAGE = 2;
export const AFTER_LOGIN_REWARD_PAGE = 3;

// SH009: GST on a salon booking, as a percentage charged on top of the subtotal.
// Mirrors `salon_gst_rate` in minty.crm.api's config/const.php — the review screen only
// previews the number, the API recomputes it, and the two have to agree.
export const SALON_GST_RATE = 9;

// SH009/SH010: mirrors MintySalonBooking's status constants in minty.crm.api.
export const SALON_BOOKING_CONFIRMED = 1;
export const SALON_BOOKING_CANCELLED = 2;
export const SALON_BOOKING_COMPLETED = 3;

// M977: mirrors MintyPromoCode::APPLY_SCOPE_* — what a promo code discounts.
export const PROMO_APPLY_SCOPE_BILL = 1;
export const PROMO_APPLY_SCOPE_REPORT_GROUP = 2;
